import { render } from "./TransactionsHistory.vue?vue&type=template&id=274bfbb5&scoped=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js"

import "./TransactionsHistory.vue?vue&type=style&index=0&id=274bfbb5&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274bfbb5"],['__file',"src/views/TransactionsHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "274bfbb5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('274bfbb5', __exports__)) {
    console.log('reload')
    api.reload('274bfbb5', __exports__)
  }
  
  module.hot.accept("./TransactionsHistory.vue?vue&type=template&id=274bfbb5&scoped=true", () => {
    console.log('re-render')
    api.rerender('274bfbb5', render)
  })

}


export default __exports__